<template>

  <fragment v-if="show">
<!--
    <LoginHeader></LoginHeader>

    <h1 class="bold text-center">
      Complete your profile
    </h1>
    <div class="sep-64"></div>
    <div class="columns is-centered">
      <div class="column is-3">
        <div class="box1">
          <div class="box1-title font-bold">
            Looking to raise funds
          </div>
          <div class="sep-16"></div>
          <button class="button is-fullwidth" @click="selectUserType('startup')">
            Continue as a startup
          </button>
        </div>
      </div>
      <div class="column is-3">
        <div class="box1 investor">
          <div class="box1-title font-bold">
            Looking to invest in startups
          </div>
          <div class="sep-16"></div>
          <button class="button is-fullwidth" @click="selectUserType('investor')">
            Continue as an investor
          </button>
        </div>
      </div>
    </div>-->
  </fragment>
</template>
<script>
import LoginHeader from "@/shared/components/LoginHeader";
import GoogleLogin from "@/modules/login/components/GoogleLogin";
import FacebookLogin from "@/modules/login/components/FacebookLogin";
import {mapGetters} from "vuex";
import store from "@/store";
import {isConnexDoor} from "@/shared/utils";

export default {
  name: "UserType.vue",
  components: {LoginHeader, GoogleLogin, FacebookLogin},
  data() {
    return {
      show: false
    }
  },
  async mounted() {
    setTimeout(() => {
      if (typeof rewardful !== "undefined") {
        rewardful('convert', {email: this.userInfo.email})
      }

      if (window.localStorage.getItem('isInvestor') === '1') {
        this.$router.push({
          name: 'investor-profile',
          query: {
            priceId: this.$route.query.priceId
          }
        })
      } else {
        this.$router.push({
          name: 'startup-profile',
          query: {
            priceId: this.$route.query.priceId
          }
        });
      }
    }, 500);
  },
  methods: {
    /**
     *
     * @param {string} type
     */
    selectUserType(type) {
      if (type === 'investor') {
        this.$router.push({
          name: 'investor-profile',
          query: {
            priceId: this.$route.query.priceId
          }
        })
      } else {
        this.$router.push({
          name: 'startup-profile',
          query: {
            priceId: this.$route.query.priceId
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  }

}
</script>

<style scoped lang="scss">
.box1 {
  margin: auto;
  height: 450px;
  width: 304px;
  padding: 24px;
  border-radius: 8px;
  //background: linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  background-image: url(../../../images/startup.svg);
  background-repeat: no-repeat;
  background-size: contain;
  border: 1px solid #eee;

  &.investor {
    background-image: url(../../../images/investor.svg);
  }

  .box1-title {
    color: #333;
    font-size: 28px;
    letter-spacing: 0;
    line-height: 32px;

  }
}
</style>
